import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "getting-started" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Getting Started", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "vue3-charts"),
  /*#__PURE__*/_createTextVNode(" is a SVG-based charting library that is very easy to use and highly customizable. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "1. Installation", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" You can install vue3-charts using "),
  /*#__PURE__*/_createElementVNode("code", null, "yarn"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("code", null, "npm"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<p> And you are done with the installation. Please keep in mind you need a Vue version &gt; 3.x </p><h2>2. Creating your first Chart</h2><p> To create your first chart you just import the <code>Chart</code> component from <b>vue3-charts</b> and add as many <b>layers &amp; widgets</b> as you want. </p><p>Here is a simple line chart example with 2 layers:</p><ul><li>- Grid layer</li><li>- Line layer</li></ul>", 5)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", null, "3. More Charts", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Check the "),
  /*#__PURE__*/_createElementVNode("a", { href: "/docs/charts" }, "charts"),
  /*#__PURE__*/_createTextVNode(" section for more examples. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeBlock = _resolveComponent("CodeBlock")!
  const _component_SimpleLineChart = _resolveComponent("SimpleLineChart")!
  const _component_ChartBlock = _resolveComponent("ChartBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode(_component_CodeBlock, {
      code: _ctx.code.npmInstall,
      readonly: true,
      lang: "bash"
    }, null, 8, ["code"]),
    _hoisted_6,
    _createVNode(_component_ChartBlock, {
      chartCode: _ctx.code.chartCode,
      dataCode: _ctx.code.dataCode
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SimpleLineChart)
      ]),
      _: 1
    }, 8, ["chartCode", "dataCode"]),
    _hoisted_11,
    _hoisted_12
  ]))
}